import { Loader2 } from "lucide-react"
import { cn } from "@/lib/utils"
import { LayoutSkeleton } from './LayoutSkeleton'

interface LoadingProps {
  className?: string
  size?: 'sm' | 'md' | 'lg'
}

const sizeClasses = {
  sm: 'h-4 w-4',
  md: 'h-8 w-8',
  lg: 'h-12 w-12',
}

export function Loading({ className = '', size = 'md' }: LoadingProps) {
  return (
    <div className={cn("flex items-center justify-center", className)}>
      <Loader2 className={cn("animate-spin text-primary", sizeClasses[size])} />
    </div>
  )
}

// Alias for backward compatibility
export const Spinner = Loading

export { LayoutSkeleton }

export function PageLoading() {
  return <LayoutSkeleton />
}
